import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { UpdateOrgContractDocumentMutation, UpdateOrgContractDocumentMutationVariables } from '@/graphql/generated/graphql';
import { UpdateOrgContractDocumentDocument } from '@/graphql/generated/graphql';
export type OrgContractDocumentUpdateInput = {
  ItemId: string
  OrganizationIds?: string[]
  OrganizationId?: string
  GuestSessionId?: string
  Name?: string
  TemplateId?: string
  TemplateSlug?: string
  TemplateTitle?: string
  Status?: string
  IsArchived?: boolean
  IsInTrash?: boolean
  FormData?: string
  EnrichmentContext?: string
  DynamicFields?: string
  CurrentStep?: number
  ProgressPercent?: number
  Document?: string
  Signatories?: string
  SigDocumentUrl?: string
  SigDocumentId?: string
  SigOrgId?: string
  CompletedAt?: string
  HasSentForApproval?: boolean
  IsApproved?: boolean
  Reviewers?: string[]
}

export type UpdateOrgContractDocumentResponse = {
  data: {
    updateOrgContractDocument: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useUpdateOrgContractDocument = () => {
  const mutation = useMutation({
    mutationKey: ['update-org-contract-document'],
    mutationFn: (variables: OrgContractDocumentUpdateInput) => {
      return graphqlClient.request<UpdateOrgContractDocumentMutation>(UpdateOrgContractDocumentDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    updateOrgContractDocument: mutation.mutate,
    updateOrgContractDocumentAsync: mutation.mutateAsync,
  }
}

export const UPDATE_ORG_CONTRACT_DOCUMENT_MUTATION = UpdateOrgContractDocumentDocument;
